import { DateTime } from 'luxon';

export function validateDraftEffectiveDate(
  effectiveDate: string,
  setErrorMessage: (message: string | undefined) => void
) {
  const endorsementDateTime = DateTime.fromISO(effectiveDate);
  const currentDateTime = DateTime.fromMillis(Date.now());
  const minEndorsementDateTime = currentDateTime.minus({ day: 30 });
  const maxEndorsementDateTime = currentDateTime.plus({ day: 30 });

  const validBackDated = endorsementDateTime >= minEndorsementDateTime;

  const validFutureDated = endorsementDateTime <= maxEndorsementDateTime;

  if (!validBackDated) {
    setErrorMessage(`Endorsement date can't more than 30 days in the past.`);
    return false;
  } else if (!validFutureDated) {
    setErrorMessage(`Endorsement date can't more than 30 days in the future.`);
    return false;
  } else {
    setErrorMessage(undefined);
  }

  return true;
}
